// extracted by mini-css-extract-plugin
module.exports = {"icon":"ErpSyncButton_icon__25eQY"};